/* global isFrientSite */

'use strict';
var novicell = novicell || {};

novicell.slideshowMobile = novicell.slideshowMobile || new function () {

    this.init = function () {
        const onResize = novicell.debounce(setSectionMargin, 100);
        window.addEventListener('resize', onResize);

        window.setTimeout(function () {
            onResize();
        });
    };

    function setSectionMargin() {
        const isMobile = window.innerWidth < 768;
        if (!isMobile) {
            return;
        }

        let getSlideshows = document.querySelectorAll('.slideshow');

        if (!getSlideshows || getSlideshows.length <= 0) {
            return;
        }

        for (let i = 0; i < getSlideshows.length; i++) {
            var currentSlideshow = getSlideshows[i];
            let getAllContentElements = currentSlideshow.querySelectorAll('.js-slide-content');
            if( currentSlideshow.classList.contains('no-images')){ continue; }
            var list = [];

            // return if no elements
            if (!getAllContentElements || getAllContentElements.length <= 0) {
                continue;
            }
            for (let i = 0; i < getAllContentElements.length; i++) {
                getAllContentElements[i].style.minHeight = "0";
            }
            for (let i = 0; i < getAllContentElements.length; i++) {
                var contentElement = getAllContentElements[i];
                list.push(contentElement.clientHeight);
            }
            // Get highest value in array
            var highestElement = Math.max(...list);
            for (let i = 0; i < getAllContentElements.length; i++) {
                getAllContentElements[i].style.minHeight = highestElement+"px";
            }


            const closetsParent = currentSlideshow.closest(".grid-section");
            if(closetsParent) {
                const nextSibling = closetsParent.nextElementSibling;

                if(nextSibling) {
                    nextSibling.style.marginTop = highestElement+"px";
                }
            }
        }
    }
}();
